export function fromHtmlEntities(string: string): string {
    return (string + "").replace(/&#\d+;/gm, (s: string) => {
        // @ts-ignore
        return String.fromCharCode(s.match(/\d+/gm)[0]);
    });
}